import { useState } from "react";

import "./stylesSportsbookVIPModal.css";

import { CloseOutlined } from "@ant-design/icons";

import { message, Select } from "antd";
import { AppStrings } from "../../../../../utils/constants/AppStrings";
import RebetLoader from "../../../../CommonComponents/RebetLoader/RebetLoader";
import { usePatchBetLimitsTier } from "../../../../../queries/user-card/usePatchBetLimitsTier";
import {
  SPORTSBOOK_TIER_OPTIONS,
  normalizeSportsbookTier,
} from "../../../../../utils/constants/sportsbookTiers";

function SportsbookVIPModal({ handleCancel, onSuccess, data, currentTier }) {
  const [tier, setTier] = useState(() => normalizeSportsbookTier(currentTier));

  const { mutate: patchTier, isPending } = usePatchBetLimitsTier();

  const onCancel = () => {
    handleCancel();
  };

  const onSave = () => {
    patchTier(
      { user_id: data.user_id, tier },
      {
        onSuccess: (res) => {
          message.success(res?.message ?? AppStrings.BET_LIMITS_TIER_UPDATED);
          onSuccess();
        },
        onError: () => {
          message.error(AppStrings.FAILED_TO_UPDATE_SPORTSBOOK_TIER);
        },
      },
    );
  };

  return (
    <div className="sportsbook-vip-modal-container">
      <div className="modal-header">
        <div className="modal-header-title">
          <h2 className="modal-title">{AppStrings.SPORTSBOOK_TOGGLES}</h2>
        </div>
        <CloseOutlined onClick={onCancel} className="close-icon" />
      </div>

      <div className="modal-content">
        <div className="modal-content-title">
          <span>
            {AppStrings.USER}: {data.username}
          </span>
        </div>
        <div className="transaction-info-item">
          <span>{AppStrings.SPORTSBOOK_TIER}</span>
          <Select
            className="sportsbook-tier-select"
            value={tier}
            onChange={setTier}
            options={SPORTSBOOK_TIER_OPTIONS}
            disabled={isPending}
            aria-label={AppStrings.SPORTSBOOK_TIER}
          />
        </div>
      </div>

      <div className="modal-footer">
        <div className="buttons">
          <button
            className="cancel-button"
            onClick={onCancel}
            disabled={isPending}
          >
            {AppStrings.CLOSE}
          </button>
          <button className="save-button" onClick={onSave} disabled={isPending}>
            {isPending ? (
              <RebetLoader height={"20px"} width={"20px"} />
            ) : (
              AppStrings.SAVE
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SportsbookVIPModal;
